module.exports = global["$"] = require("-!/tmp/build_15bda8ce/node_modules/babel-loader/lib/index.js??ref--12-0!./jquery.js");